import { useOmnisearchStore } from "hooks/omnisearch-v2";
import { NoRowsOverlay } from "routes/Customer/Chemicals/Inventory/Facility/NoRowsOverlay";
import {
  useClearFiltersToPeriod,
  withoutPeriodTerm,
} from "routes/Customer/Waste/Invoices/invoiceTrackingPeriod";

/**
 * The grid's empty state. The period is always in the search, so it is not a
 * filter here: with nothing else applied, an empty report means no schedule
 * covers the period, and clearing a search keeps the period.
 */
export function EmptyResults() {
  const { omnisearch } = useOmnisearchStore();
  const clearFilters = useClearFiltersToPeriod();
  if (withoutPeriodTerm(omnisearch).trim() === "") {
    return (
      <NoRowsOverlay
        message="No vendor schedules have been imported for this period."
        showButton={false}
      />
    );
  }
  return (
    <NoRowsOverlay
      message="No results found."
      buttonText="Clear search"
      onButtonClick={clearFilters}
    />
  );
}
